import React from 'react';
import MinigameCenter from '../../components/Minigame/MinigameCenter';
import SportsRight from '../../components/sports/SportsRight';

const HighLow = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <MinigameCenter type="highlow"/>
            <SportsRight type="minigame"/>
        </div>
    );
};

export default HighLow;


// WEBPACK FOOTER //
// ./src/containers/minigame/HighLow.js